import React from 'react';
import { graphql } from "gatsby";
import PropTypes from 'prop-types';
import AnimationWrapper from '../../globals/animationWrapper/animationWrapper';
import ContentBlock from '../../components/contentBlock/contentBlock';
import Image from '../../components/image/image';
import Link from '../../components/link/link';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';

/**
 * CMS Component: DatoCmsModuleParallax
 * 
 */
const Parallax = ({data, className, ...other}) => {
  let {anchor, border, cta, images, link, logos} = data || {};
  return (
    <ModuleWrapper container={false} anchor={anchor} border={border} className={`parallax ${className || ''}`} {...other}>
      {
        images[1] && 
        <AnimationWrapper animationtype={`parallax`}>
          <Image className="parallax__img" data={images[1]} />
        </AnimationWrapper>
      }

      {
        (cta && cta[0]) && 
        <div className="parallax__cta container">
          <ContentBlock className="Default" data={cta[0]}/>
        </div>
      }        
      <div className="parallax__logos" >
        {
          images[2] && <Image className="backgroundMedia mobile" data={images[2]} />
        }
         {
          images[0] && <Image className="backgroundMedia tablet-min" data={images[0]} />
        }

        <div className="container Reversed">
          <div className="logos__content">
            {
              logos?.map((tile, i)=>{
                return <Image className="logo" data={tile} key={i} width={157} />
              })
            }
          </div>
          
          {
            link && <Link data={link} className="btn--primary--inverse"/>
          }
        </div>
      </div>
    </ModuleWrapper>
  );
};

Parallax.propTypes = {
   /**
    * Data from cms
    */
    data : PropTypes.shape({
      anchor: PropTypes.string,
      border: PropTypes.string,
      cta: PropTypes.array,
      images: PropTypes.array,
      link: PropTypes.array,
      logos: PropTypes.array
    })
};

export default Parallax;

export const ModuleParallaxFragment = graphql`
fragment ModuleParallaxFragment on DatoCmsModuleParallax {
  anchor
  border
  cta{
    ...EyebrowHeadingCopyLinkFragment
  }
  images{
    ...BackgroundImageFragment
  }
  link{
      ...LinkFragment
  }
  logos{
    ...LogoFragment
  }
}
`;